$(document).ready(function() {
    if( typeof avastDownloadLink !== 'undefined'
        && (avastDownloadLink.slice(-4) === '.exe'
            || avastDownloadLink.slice(-4) === '.dmg'
            || avastDownloadLink.slice(-4) === '.pkg'
            || avastDownloadLink.slice(-4) === '.msi'
            || avastDownloadLink.slice(-4) === '.u3p'
            || avastDownloadLink.slice(-4) === '.zip'
            || avastDownloadLink.match(/^https?:\/\/bits.ff.avast.com\//)
            || avastDownloadLink.match(/^https?:\/\/bits.avcdn.net\//)
            || avastDownloadLink.match(/^https:\/\/cdn-download\.avastbrowser\.com\//)
        ) ) {
        $('.note').hide( function() {
            $('.noteProgress').fadeIn( function() {
                setTimeout(
                    function() {
                        window.location = avastDownloadLink;
                    }
                    ,2500
                );
                setTimeout(
                    function() {
                        $('.noteProgress').fadeOut( function() {
                            $('.note').fadeIn().css("display","inline-block");
                        });
                    }
                    ,4000
                );
            });
        });
    }
    else{
        $('.noteProgress').hide( function() {
            $('.note').fadeIn().css("display","inline-block");
        });
    }

  //Normalize "progress" help boxes on DTP
  if( typeof avast.core !== 'undefined' ) {
    avast.core.normalizeStyle('.same-height', 'height');
	if($(".feature").length > 0) {
		avast.core.normalizeStyle('.feature', 'height');
	}
  }

/*
    //TPMO5315
    var pABTest = {
        'TPMO5315' : {
            'products' : {
                'PRE' : [
                    '//files.avast.com/iavs9x/avast_premier_antivirus_setup.exe',
                    '//files.avast.com/iavs9x/avast_premier_antivirus_setup.exe'
                ],
                'IS' : [
                    '//files.avast.com/iavs9x/avast_internet_security_setup.exe',
                    '//files.avast.com/iavs9x/avast_internet_security_setup.exe'
                ],
                'PAV' : [
                    '//files.avast.com/iavs9x/avast_pro_antivirus_setup.exe',
                    '//files.avast.com/iavs9x/avast_pro_antivirus_setup.exe'
                ]
            },
            random : function(){
                return Math.round(Math.random());
            }
        }
    }

	var productDWNL = $(document).getUrlParam('product');
	if (productDWNL == "FA-ONLINE"){
		$(".offlinep").show();
	}
  if (productDWNL == "FAV-ONLINE"){
		$(".offlinep").show();
	}
	if (productDWNL == "ISE-ONLINE"){
		$(".offlinep").show();
        $(".offlinep a").attr("href","//files.avast.com/iavs9x/avast_internet_security_setup.exe");    
        
        //TPMO5315
        if(locale == 'en-us' || locale == 'fr-fr' || locale == 'pt-br' || locale == 'ru-ru' ){
            $(".offlinep a").attr("href", pABTest.TPMO5315.products.IS[ pABTest.TPMO5315.random() ]);
        }
    }
	if (productDWNL == "PRE-ONLINE"){
		$(".offlinep").show();
		$(".offlinep a").attr("href","//files.avast.com/iavs9x/avast_premier_antivirus_setup.exe");

        //TPMO5315
        if(locale == 'en-us' || locale == 'fr-fr' || locale == 'pt-br' || locale == 'ru-ru' ){
            $(".offlinep a").attr("href", pABTest.TPMO5315.products.PRE[ pABTest.TPMO5315.random() ]);
        }
	}
    if (productDWNL == "PAV-ONLINE"){
		$(".offlinep").show();
		$(".offlinep a").attr("href","//files.avast.com/iavs9x/avast_pro_antivirus_setup.exe");

        //TPMO5315
        if(locale == 'en-us' || locale == 'fr-fr' || locale == 'pt-br' || locale == 'ru-ru' ){
            $(".offlinep a").attr("href", pABTest.TPMO5315.products.PAV[ pABTest.TPMO5315.random() ]);
        }
	}

	if($(".showText").length > 0){
		classToShow = productDWNL.toLowerCase();
		$("."+classToShow).show();
	}
*/

});

/**
 * Append data attribute with downloadName to link (OO-3785)
 */

(function() {
    var params = avm.require('avast.url.unserialize')(),
        link = document.querySelector('.bi-download-link'),
        businessLink = document.querySelector('.business-download-button');

    if (params && params.product && link) {
        if ('dataset' in link) {
            link.dataset.biDownloadName = params.product;
        } else {
            link.setAttribute('data-bi-download-name', params.product)
        }
    }

    if (params && params.product && businessLink) {
        if ('dataset' in businessLink) {
            businessLink.dataset.biDownloadName = params.product;
        } else {
            businessLink.setAttribute('data-bi-download-name', params.product)
        }
    }
})();


// Add attribute 'data-bi-download-name' to download links
(function() {
    'use strict';
    var $ = avm.require('jquery'),
        params = avm.require('avast.url.unserialize')(),
        $links = $('.bi-download-link'),
        $businessLinks = $('.business-download-button');

    if (params && params.product) {
        $links.add($businessLinks).each(function() {
            $(this).attr('data-bi-download-name', params.product);
        });
    }
})();
